import { connect } from 'react-redux';
import { change } from 'redux-form';
import qs from 'qs';
import { createSub, fetchAllQuickInitialsSubs } from 'actions/quickSubs';
import {
  getSubmitStatus,
  getNewSubSubmitSucceeded,
  getCreatedQuickSub,
  getAllQuickInitialsSubs,
  getAllQuickInitialsSubsStatus,
} from 'reducers';
import userPage from 'decorators/userPage';
import CreateSub from './CreateSub';
import { compose } from 'redux';
import withQuickSubOptions from 'decorators/withQuickSubOptions';

const mapStateToProps = (state, { location: { search } }) => {
  const { preactivation: preactivationId } = qs.parse(search, {
    ignoreQueryPrefix: true,
  });

  return {
    saveStatus: getSubmitStatus(state, 'sub'),
    submitSucceeded: getNewSubSubmitSucceeded(state),
    sub: getCreatedQuickSub(state),
    initialSubs: getAllQuickInitialsSubs(state),
    initialSubsLoading: getAllQuickInitialsSubsStatus(state) === 'PENDING',
    heading: 'Create a Quick Subscription',
    redirectUrl: (sub) => `/quick/subscriptions/${sub.id}/view`,
    preactivationId,
    carrierPrefix: 'quick',
    isQuick: true,
  };
};

const mapDispatchToProps = (dispatch, { user }) => ({
  onSubmit: (values) => dispatch(createSub(values)),
  fetchAllInitialsSubs: (params, options) =>
    dispatch(fetchAllQuickInitialsSubs(params, options)),
  useUserName: () => {
    dispatch(change('sub', 'first_name', user && user.first_name));
    dispatch(change('sub', 'last_name', user && user.last_name));
  },
});

export default compose(
  userPage,
  withQuickSubOptions,
  connect(mapStateToProps, mapDispatchToProps),
)(CreateSub);
